import { createSlice } from '@reduxjs/toolkit'

export const usersGroupsFilterSlice = createSlice({
    name: 'usersGroupsFilter',
    initialState: {
        id: "",
        name: ""
    },
    reducers: {
        edit: (state, payload) => {
            state = {
                ...state, 
                ...payload.payload
            };
            return state;
        }
    },
})

export const { edit } = usersGroupsFilterSlice.actions

export default usersGroupsFilterSlice.reducer